export default {
  toolbarBtnSelected: {
    color: '#ffffff !important'
  },
  toolbarTxt: {
    color: '#ffffff !important'
  }
}
